export const customerNumberNewMax = 99999999;
export const customerReferenceNumberMax = 20;
export const discountMax = 1000000;
export const additionalFeeMax = 4000000;
export const totalPriceMax = 4000000;
export const invoiceDescriptionMax = 2000;
export const adminInfoMax = 2000;
